(() => {
  const formSelector = '.br-newsletter-form';
  const responseSelector = '.br-newsletter-form__response';
  const fieldsSelector = '.br-newsletter-form__fields';
  const stateSelector = '[data-br-newsletter-state]';
  const emailSelector = '[data-br-newsletter-email]';
  const squeezeQuery = window.matchMedia('(min-width: 990px)');
  let pageShown = document.readyState === 'complete';

  const decodeTargetId = () => {
    try {
      return decodeURIComponent(window.location.hash.replace(/^#/, ''));
    } catch {
      return '';
    }
  };

  const reconcile = () => {
    const targetId = decodeTargetId();
    let focusTarget = null;

    document.querySelectorAll(formSelector).forEach((form) => {
      const stateRoot = form.querySelector(stateSelector);
      const state = stateRoot?.dataset.brNewsletterState || 'idle';
      const response = form.querySelector(responseSelector);
      const fields = form.querySelector(fieldsSelector);
      const email = form.querySelector(emailSelector);
      const isSubmittedForm = Boolean(form.id === targetId && state !== 'idle' && response);

      if (response) response.hidden = !isSubmittedForm;
      if (fields) fields.hidden = Boolean(isSubmittedForm && state === 'success');

      if (email) {
        if (isSubmittedForm && state === 'error' && response.id) {
          email.setAttribute('aria-invalid', 'true');
          email.setAttribute('aria-describedby', response.id);
          focusTarget = email;
        } else {
          email.removeAttribute('aria-invalid');
          email.removeAttribute('aria-describedby');
          if (!isSubmittedForm && state !== 'idle') email.value = '';
        }
      }

      if (isSubmittedForm && state === 'success') focusTarget = response;
    });

    if (focusTarget && pageShown) {
      window.requestAnimationFrame(() => {
        /* Horizon owns vertical scrolling in .page-wrapper only in the desktop
           squeeze layout. Shopify's action fragment can also scroll the outer
           document there, lifting that wrapper and leaving a blank band below
           it. On mobile the document is the intentional scroll root, so keep
           its native fragment position. */
        if (squeezeQuery.matches) window.scrollTo(0, 0);
        focusTarget.focus({ preventScroll: true });
      });
    }
  };

  reconcile();
  /* Deferred scripts can run before the browser applies its final fragment
     position. Scope the response immediately, but wait to focus and correct
     desktop outer scroll until the document is actually shown. */
  window.addEventListener('pageshow', (event) => {
    pageShown = true;
    /* A bfcache restore replays pageshow. The document comes back with its
       scroll and focus already restored, so correcting it again would move the
       page under a visitor who simply pressed Back. */
    if (event && event.persisted) return;
    reconcile();
  });
  window.addEventListener('hashchange', reconcile);
})();
